<template>
  <div>
    <v-row justify="center">
      <v-dialog
        v-model="inputedValue"
        scrollable
        :width="width"
        contentClass="rounded-xl"
      >
        <v-card>
          <v-card-title class="primary white--text">
            <slot name="title" v-bind:dialogTitle="title">
              <span class="pl-3">{{ $t(title) }}</span>
            </slot>
            <v-spacer> </v-spacer>
            <v-btn icon @click="close()">
              <v-icon class="white--text">mdi-close </v-icon>
            </v-btn>
          </v-card-title>
          <v-divider> </v-divider>
          <v-card-text
            class="cardTextStyle"
            v-bind:class="{
              cardBackgroundStyle: isCardColor,
              isPadding0: isPadding0,
              isPaddingNormal: !isPadding0
            }"
          >
            <slot />
          </v-card-text>
          <v-divider v-if="isFooter"> </v-divider>
          <v-card-actions v-if="isActions" v-bind:class="footerColorChange">
            <slot name="footer" />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    isPadding0: { default: false },
    isCardColor: { default: false },
    isFooterColor: { default: true },
    isFooter: { default: false },
    isActions: { default: true }
  },
  data: () => ({
    displayFlg: false
  }),
  methods: {
    close() {
      this.inputedValue = false
    },
    complete() {
      this.inputedValue = false
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    footerColorChange: function () {
      return {
        cardBackgroundStyle: this.isCardColor && !this.isFooterColor
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.cardTextStyle {
  // background-color: #f6f6f6;
  font-size: 14px;
  color: #000 !important;
}
.cardBackgroundStyle {
  background-color: #f6f6f6;
  // font-size: 14px;
}
.isPadding0 {
  padding: 0px !important;
}
.isPaddingNormal {
  padding: 10px !important;
}
.cardActionsStyle {
  background-color: #f9fbfe;
}
.dialogTitleStyle {
  font-size: 22px;
}
.border {
  border: 1px solid #d8d8d8 !important;
}
</style>
